export default __webpack_public_path__ + "static/media/categories.71163707.svg";